import { render, staticRenderFns } from "./order-manage.vue?vue&type=template&id=d16894aa&scoped=true&"
import script from "./order-manage.vue?vue&type=script&lang=js&"
export * from "./order-manage.vue?vue&type=script&lang=js&"
import style0 from "./order-manage.vue?vue&type=style&index=0&id=d16894aa&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d16894aa",
  null
  
)

export default component.exports